export default "__VITE_ASSET__CPcTVM2R__"